import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedService } from '../../../../../shared/services/shared.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from "../../../../../shared/components/button/button.component";

@Component({
  selector: 'app-digital-consent-modal',
  imports: [CommonModule, FormsModule, TranslateModule, ButtonComponent],
  templateUrl: './digital-consent-modal.component.html',
  styleUrl: './digital-consent-modal.component.scss'
})
export class DigitalConsentModalComponent implements OnChanges {
  @Input() data: any;
  @Output() onSubmit = new EventEmitter<any>();
  termContent: any;
  isAccepted = false;
  showTermsError = false;
  today = new Date();
  // This method is used to initialize the class instance using shared service
  constructor(
    private sharedService: SharedService
  ) {

  }
  // This method is used to handle the on changes lifecycle hook using changes
  ngOnChanges(changes: SimpleChanges): void {
    if (this.data) {
      this.termContent = this.sharedService.getATAConsentDetail(this.data);
    }
  }
  // This method is used to handle accept terms change event using value
  onAcceptTermsChange(value: boolean) {
    this.isAccepted = value;
    if (value) {
      this.showTermsError = false;
    }
  }

  // This method is used to submit pledge
  submitPledge() {
    if (!this.isAccepted) {
      this.showTermsError = true;
      return;
    }
    this.showTermsError = false;
    this.onSubmit.emit(true);
  }

}
